// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function AddpanelDownloads(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'AddpanelDownloads',
      'aria-hidden': true,
      focusable: false,
      width: 44 * scale,
      height: 38 * scale,
      viewBox: '0 0 44 38',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: '#000',
      fillOpacity: '.4',
      fillRule: 'evenodd',
      d: 'M0 0h44v38H0V0zm1 1v36h42V1H1z',
      clipRule: 'evenodd',
    }),
    createElement('path', {
      fill: 'currentColor',
      fillOpacity: '.2',
      fillRule: 'evenodd',
      d: 'M1 1h42v36H1V1z',
      clipRule: 'evenodd',
    }),
    createElement('path', {
      fill: 'currentColor',
      d: 'M41 8v4h2V8h-2zm2 6h-2v4h2v-4zm0 6h-2v4h2v-4zm0 6h-2v4h2v-4zm0 6h-2v3h-3v2h5v-5zm-7 5v-2h-4v2h4zm-6 0v-2h-4v2h4zm-6 0v-2h-4v2h4zm-6 0v-2h-4v2h4zm-6 0v-2H8v2h4zm-6 0v-2H3v-3H1v5h5zm-5-7h2v-4H1v4zm0-6h2v-4H1v4zm0-6h2v-4H1v4zm0-6h2V8H1v4zm0-6h2V3h3V1H1v5zm7-5v2h4V1H8zm6 0v2h4V1h-4zm6 0v2h4V1h-4zm6 0v2h4V1h-4zm6 0v2h4V1h-4zm6 0v2h3v3h2V1h-5zM25.535 12.636l.708.707-8.486 8.485a1 1 0 101.415 1.415l8.131-8.132a2.5 2.5 0 00-3.535-3.536l-8.132 8.132a4 4 0 005.657 5.657l8.485-8.485.707.707L22 26.07A5 5 0 0114.929 19l8.132-8.132a3.5 3.5 0 114.95 4.95l-8.132 8.132a2 2 0 11-2.829-2.829l8.485-8.485z',
    })
  );
}
